<template>
    <v-container>
        <v-dialog v-model="dialogDesconciliarViagem" max-width="80%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogDesconciliarViagem">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.desconciliarViagem.title') }}</v-toolbar-title>
                </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-card flat class="mb-4 viagem-ident-card" color="grey lighten-4">
                        <v-card-text class="pb-2">
                            <div class="text-overline grey--text text--darken-1 mb-2">
                                {{ $t('conciliacaoViagens.dialogs.desconciliarViagem.reconciledTrip') }}
                            </div>
                            <v-row dense align="stretch">
                                <v-col cols="12" md="5">
                                    <div class="d-flex align-center flex-wrap viagem-ident-block primary--text">
                                        <v-icon color="primary" class="mr-3" large>mdi-bus-marker</v-icon>
                                        <div>
                                            <div class="text-caption grey--text text--darken-2 mb-0">
                                                {{ $t('conciliacaoViagens.headers.line') }}
                                            </div>
                                            <div class="text-h6 font-weight-bold primary--text">
                                                {{ linhaConciliadaLabel }}
                                            </div>
                                            <v-chip
                                                v-if="viagemConciliada?.descricao_sentido"
                                                small
                                                class="mt-1"
                                                color="primary"
                                                outlined
                                            >
                                                {{ viagemConciliada.descricao_sentido }}
                                            </v-chip>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.vehicle') }}
                                        </div>
                                       <div class="text-h6 font-weight-bold">
                                            {{ viagemConciliada?.numero_ordem_veiculo_realizado || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.realizedDepartureTime') }}
                                        </div>
                                        <div class="text-body-1 font-weight-bold">
                                            {{ viagemConciliada?.horario_saida_realizada_extenso || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="3">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.realizedArrivalTime') }}
                                        </div>
                                        <div class="text-body-1 font-weight-bold">
                                            {{ viagemConciliada?.horario_chegada_realizada_extenso || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-divider class="my-3"></v-divider>
                            <v-row dense align="stretch">
                                <v-col cols="12" sm="6" md="4">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.startFence') }}
                                        </div>
                                        <div class="text-body-2 font-weight-medium">
                                            {{ viagemConciliada?.nome_cerca_inicio || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.endFence') }}
                                        </div>
                                        <div class="text-body-2 font-weight-medium">
                                            {{ viagemConciliada?.nome_cerca_fim || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.driver') }}
                                        </div>
                                        <div class="text-body-2 font-weight-medium">
                                            {{ motoristaConciliadoLabel || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.kmAferido') }}
                                        </div>
                                        <div class="text-h6 font-weight-bold" style="color: #1976d2;">
                                            {{ viagemConciliada?.km_aferido ?? '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.headers.kmNominal') }}
                                        </div>
                                        <div class="text-h6 font-weight-bold">
                                            {{ viagemConciliada?.km_nominal ?? '—' }}
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="4" md="2">
                                    <div class="viagem-ident-block">
                                        <div class="text-caption grey--text text--darken-2">
                                            {{ $t('conciliacaoViagens.filters.realized') }}
                                        </div>
                                        <div
                                            class="text-h6 font-weight-bold"
                                            :class="viagemConciliada?.realizada == 1 ? 'success--text' : 'grey--text'"
                                        >
                                            {{ viagemConciliada?.realizada_extenso || '—' }}
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-row>
                        <v-col cols="12" sm="12" md="4">
                            <v-select
                                v-model="idMotivoDesconciliacao"
                                :items="motivos"
                                :label="$t('conciliacaoViagens.dialogs.desconciliarViagem.unconciliationReason')"
                                item-text="descricao_motivo"
                                item-value="id_motivo"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="8">
                            <v-text-field
                                v-model="observacoesDesconciliacao"
                                :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="desconciliarViagem">{{ $t('conciliacaoViagens.dialogs.desconciliarViagem.confirm') }}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogInserirMotivoConciliacao"
            max-width="80%"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogInserirMotivoConciliacao">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{$t('conciliacaoViagens.insertReason')}}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="4">
                                <v-select 
                                    v-model="idMotivoConciliacao" 
                                    :items="motivos" 
                                    :label="$t('conciliacaoViagens.dialogs.editTrip.manualConciliationReason')" 
                                    item-text="descricao_motivo" 
                                    item-value="id_motivo"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                                <v-text-field v-model="observacoesConciliacao" :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="conciliar(viagemOperadoraSelected)">{{$t('button.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogCancelarViagem"
            max-width="80%"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeCancelarViagemDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.cancelConciliation.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="viagemEditadaBloqueada" type="warning" dense text
                            icon="mdi-lock-outline" style="border-radius: 10px">
                            {{ avisoViagemMesFechado(editedViagem, idEmpresaSelected) }}
                        </v-alert>
                        <v-row>
                            <v-col cols="12" sm="12" md="4">
                                <v-switch v-model="editedViagem.conciliacao_cancelada" :disabled="viagemEditadaBloqueada" :label="$t('conciliacaoViagens.dialogs.cancelConciliation.cancelConciliation')" @change="cancelarViagemChanged"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                                <v-select v-model="editedViagem.id_motivo_conciliacao_cancelada" :disabled="viagemEditadaBloqueada" :items="motivos" :label="$t('conciliacaoViagens.dialogs.cancelConciliation.cancelConciliationReason')" item-text="descricao_motivo" item-value="id_motivo"></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="editedViagem.observacoes_conciliacao_cancelada" :disabled="viagemEditadaBloqueada" :label="$t('conciliacaoViagens.dialogs.cancelConciliation.observations')"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="viagemEditadaBloqueada" @click="cancelarViagem(editedViagem)">{{ editedViagem.conciliacao_cancelada == 1 ? $t('conciliacaoViagens.dialogs.cancelConciliation.cancelConciliation') : $t('conciliacaoViagens.dialogs.cancelConciliation.resumeConciliation') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogUploadResult" max-width="50%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogUploadResult">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.uploadResult.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container style="margin-top: 10px;">
                        <v-row>
                            <span style="font-size: 1.2rem; font-weight: bold;">{{ resultadoUpload.mensagem }}</span>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="baixarLog">{{
                        $t('conciliacaoViagens.dialogs.uploadResult.downloadLog') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDetalhesViagemOperadora" max-width="80%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogDetalhesViagemOperadora">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.tripDetails.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="viagemOperadoraSelected.observacoes"
                                    :label="$t('conciliacaoViagens.dialogs.tripDetails.observations')"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateViagemOperadora">{{
                        $t('conciliacaoViagens.dialogs.tripDetails.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEditarViagem" fullscreen>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialogEditarViagem">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('conciliacaoViagens.dialogs.editTrip.title') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-form ref="formEditarViagem" v-model="formValidadoEditarViagem">
                            <v-row>
                                <v-col cols="12" sm="4" md="3">
                                    <v-datetime-picker :label="$t('conciliacaoViagens.dialogs.editTrip.initialDate')"
                                        v-model="dtiPosicoes" :time-picker-props="timeProps"
                                        :date-picker-props="dtiProps" :text-field-props="textFieldProps"
                                        time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                                        :clear-text="$t('datetime.close')" ref="dtiPosicoesPicker">
                                        <template slot="dateIcon">
                                            <v-icon>mdi-calendar</v-icon>
                                        </template>
                                        <template slot="timeIcon">
                                            <v-icon>mdi-clock</v-icon>
                                        </template>
                                    </v-datetime-picker>
                                </v-col>
                                <v-col cols="12" sm="4" md="3">
                                    <v-datetime-picker :label="$t('conciliacaoViagens.dialogs.editTrip.finalDate')"
                                        v-model="dtfPosicoes" :time-picker-props="timeProps"
                                        :date-picker-props="dtfProps" :text-field-props="textFieldProps"
                                        time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                                        :clear-text="$t('datetime.close')" ref="dtfPosicoesPicker">
                                        <template slot="dateIcon">
                                            <v-icon>mdi-calendar</v-icon>
                                        </template>
                                        <template slot="timeIcon">
                                            <v-icon>mdi-clock</v-icon>
                                        </template>
                                    </v-datetime-picker>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-autocomplete v-model="idVeiculoSelected" :items="veiculos"
                                        item-text="numero_ordem" item-value="id_veiculo" clearable
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.vehicle')"
                                        :disabled="isVeiculoSelectDisabled"
                                        :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectVehicle')]"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="1" align="end">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs"
                                                v-on="on" @click="populaMapa" style="margin-bottom: 5px;">
                                                <v-icon>mdi-magnify</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('conciliacaoViagens.dialogs.editTrip.search') }}</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="7" md="7">
                                    <v-autocomplete v-model="idLinhaAssociada" :items="linhas" item-text="nome_linha"
                                        item-value="id_linha" :disabled="isLinhaDisabled"
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.lineName')"
                                        :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectLine')]">
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.nome_linha }}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-chip x-small color="primary" outlined>{{ item.cod_linha }}</v-chip>
                                            </v-list-item-action>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="1" md="1">
                                    <v-text-field 
                                        :value="selectedLinha ? selectedLinha.cod_linha : ''"
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.line')"
                                        readonly
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select v-model="editedViagem.id_sentido" :items="sentidos"
                                        item-text="descricao_sentido" item-value="id_sentido"
                                        :disabled="isSentidoDisabled"
                                        :label="$t('conciliacaoViagens.dialogs.editTrip.direction')"
                                        :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectDirection')]"></v-select>
                                </v-col>
                            </v-row>
                        </v-form>

                        <div id="mapcontainer">
                            <l-map ref="map" :zoom="zoom" :center="currentCenter" :options="mapOptions" @ready="onMapReady"
                                v-resize="onMapResize" :key="key">
                                <l-tile-layer :url="url" :attribution="attribution" />

                                <l-control :position="'bottomleft'" v-if="posicaoSelected">
                                    <v-card style="border-radius: 10px;">
                                        <v-card-text>
                                            <pre>{{ $t('conciliacaoViagens.map.dateTime') }}: {{ posicaoSelected?.dt_posicao_extenso }}</pre>
                                            <pre>{{ $t('conciliacaoViagens.map.speed') }}: {{ posicaoSelected?.velocidade }} {{
                                                $t('conciliacaoViagens.map.kmh') }}</pre>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="green" dark @click="atualizarViagem(1)" small
                                                :disabled="isHorarioSaidaDisabled">{{
                                                    $t('conciliacaoViagens.dialogs.editTrip.startTrip') }}</v-btn>
                                            <v-btn color="red" dark @click="atualizarViagem(2)" small
                                                :disabled="isHorarioChegadaDisabled">{{
                                                    $t('conciliacaoViagens.dialogs.editTrip.finishTrip') }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </l-control>

                                <l-control :position="'topright'">
                                    <v-card style="border-radius: 10px;">
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-checkbox v-model="showCercas"
                                                        :label="$t('conciliacaoViagens.dialogs.editTrip.fences')"></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-checkbox v-model="showRota"
                                                        :label="$t('conciliacaoViagens.dialogs.editTrip.route')"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </l-control>

                                <Vue2LeafletRotatedMarker v-for="(reg, k) in posicoes" :key="`${reg.id_veiculo}-${k}`"
                                    :lat-lng="latLng(reg.lat, reg.lng)" :icon="getIconPosicao(reg)"
                                    @click="showDetalhesPosicoes(k)" :rotationAngle="parseInt(reg.rumo)"
                                    :rotationOrigin="'15px 15px'">
                                </Vue2LeafletRotatedMarker>

                                <l-geo-json v-for="(rota, i) in rotas" :key="`ROTA-${i}`" :geojson="rota.geojson"
                                    :visible="showRota" />
                                <l-geo-json v-for="(cerca, i) in cercasGeojson" :key="`CERCA-GEOJSON-${i}`"
                                    :geojson="cerca.geojson" :options-style="cerca.style" :options="cerca.options" :visible="showCercas">
                                </l-geo-json>
                                <l-circle v-for="(cerca, i) in cercasCirculares" :key="`CERCA-CIRCULAR-${i}`"
                                    :radius="cerca.raio_mts" :lat-lng="latLng(cerca.lat_centro, cerca.lng_centro)"
                                    :options="cerca.style" :visible="showCercas">
                                    <l-tooltip :content="cerca.nome_cerca"></l-tooltip>
                                </l-circle>
                            </l-map>
                        </div>

                        <v-card style="margin-top: 10px; border-radius: 10px;">
                            <v-card-title>
                                {{ $t('conciliacaoViagens.dialogs.editTrip.trip') }}
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-form ref="formDetalhesViagem" v-model="formValidadoDetalhesViagem">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedViagem.numero_guia_realizada" readonly
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.guide')"
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedViagem.escalonamento_veiculo"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.scaling')"
                                                    :disabled="isEscalonamentoDisabled"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-datetime-picker v-model="horarioSaidaRealizada"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.realizedDeparture')"
                                                    :time-picker-props="timeProps" :date-picker-props="dtiProps"
                                                    :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                                    date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"
                                                    ref="horarioSaidaRealizadaPicker"
                                                    :disabled="isHorarioSaidaDisabled"></v-datetime-picker>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-datetime-picker v-model="horarioChegadaRealizada"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.realizedArrival')"
                                                    :time-picker-props="timeProps" :date-picker-props="dtfProps"
                                                    :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                                    date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"
                                                    ref="horarioChegadaRealizadaPicker"
                                                    :disabled="isHorarioChegadaDisabled"></v-datetime-picker>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="6">
                                                <v-autocomplete v-model="editedViagem.id_cerca_inicio" :items="cercas"
                                                    item-text="nome_cerca" item-value="id_cerca"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.startFence')"
                                                    :disabled="isCercaInicioDisabled">
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="6">
                                                <v-autocomplete v-model="editedViagem.id_cerca_fim" :items="cercas"
                                                    item-text="nome_cerca" item-value="id_cerca"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.arrivalFence')"
                                                    :disabled="isCercaFimDisabled">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field :value="editedViagem.tipo_abertura"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.opening')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field :value="editedViagem.dt_abertura_manual_extenso"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.openedAt')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4">
                                                <v-text-field :value="editedViagem.nome_usuario_abertura_manual"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.user')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field :value="editedViagem.tipo_fechamento"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.closing')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field :value="editedViagem.dt_fechamento_manual_extenso"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.closedAt')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4">
                                                <v-text-field :value="editedViagem.nome_usuario_fechamento_manual"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.user')" readonly
                                                    :disabled="true"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="4">
                                                <v-select v-model="idMotivoAbertura" :items="motivos"
                                                    item-text="descricao_motivo" item-value="id_motivo"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.openingReason')"
                                                    :disabled="isMotivoAberturaDisabled"></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-text-field v-model="observacoesAbertura"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                                    :disabled="isObservacoesAberturaDisabled"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="4">
                                                <v-select v-model="idMotivoFechamento" :items="motivos"
                                                    item-text="descricao_motivo" item-value="id_motivo"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.closingReason')"
                                                    :disabled="isMotivoFechamentoDisabled"></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <v-text-field v-model="observacoesFechamento"
                                                    :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                                    :disabled="isObservacoesFechamentoDisabled"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="4">
                                            <v-select
                                            v-model="editedViagem.id_motivo_conciliacao_manual"
                                            :items="motivos"
                                            item-text="descricao_motivo"
                                            item-value="id_motivo"
                                            :label="$t('conciliacaoViagens.dialogs.editTrip.manualConciliationReason')"
                                            readonly
                                            :disabled="true"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="8">
                                            <v-text-field
                                            v-model="editedViagem.observacoes_conciliacao_manual"
                                            :label="$t('conciliacaoViagens.dialogs.editTrip.observations')"
                                            readonly
                                            :disabled="true"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <HodometrosViagemInfo ref="hodometrosViagem"
                                                :id-viagem-grid="editedViagem.id_viagem_grid" editavel
                                                :disabled="viagemEditadaBloqueada"></HodometrosViagemInfo>
                                        </v-col>
                                    </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateViagemGrid">{{ $t('button.save') }}</v-btn>
                </v-card-actions>
            </v-card>
            >

        </v-dialog>
        <v-toolbar style="
          margin-bottom: 10px;
          margin-left: 3px;
          margin-top: 10px;
          border-radius: 10px;
          padding-top: 60px;
          padding-bottom: 20px;
          height: 200px;
        ">
            <v-container>
                <v-form ref="form" v-model="formValidado">
                    <v-row>
                        <v-col cols="12" sm="4" md="5">
                            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
                                item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                                :rules="[(v) => !!v || $t('conciliacaoViagens.validation.selectCompany')]"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                                <template slot="dateIcon">
                                    <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                    <v-icon>mdi-clock</v-icon>
                                </template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                                <template slot="dateIcon">
                                    <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                    <v-icon>mdi-clock</v-icon>
                                </template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs"
                                        v-on="on" @click="populaRelatorio">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('conciliacaoViagens.dialogs.editTrip.search') }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-toolbar>

        <v-alert
            type="warning"
            dismissible
            v-model="showAlertVeiculosDistintos"
            style="margin-bottom: 10px; border-radius: 10px"
        >
            <span>{{ $t('conciliacaoViagens.messages.alertMissingVehicles') }}</span>
            <div>{{ veiculosDistintos.join(" ") }}</div>
        </v-alert>

        <!-- Mês fechado: as viagens do período estão congeladas e a API recusa a alteração. -->
        <v-alert v-if="mesesFechadosConsultados.length" type="info" dense text
            icon="mdi-lock-outline" style="margin-bottom: 10px; border-radius: 10px">
            {{ $t('closingMonth.editBlockedBanner', { meses: mesesFechadosConsultados.join(', ') }) }}
        </v-alert>

        <merus-data-table :headers="headersWithActionsMerus" :items="viagensMerusFiltradas" :loading="loadingMerus"
            :default-multi-sort="defaultMultiSortMerus" :item-class="getViagemStyle"
            :show-columns-button="true"
            :loading-text="$t('conciliacaoViagens.tables.merusTrips.loading')"
            @update:headers="headersChanged"
            @update:displayedItems="displayedItemsForExportMerus = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('conciliacaoViagens.tables.merusTrips.title')" :token="token"
                    :items="displayedItemsForExportMerus !== null ? displayedItemsForExportMerus : viagensMerusFiltradas"
                    :csv-title="$t('conciliacaoViagens.tables.merusTrips.csvTitle')"
                    :pdf-title="$t('conciliacaoViagens.tables.merusTrips.pdfTitle')" :pdf-headers="headersViagensMerus"
                    pdf-filename="viagensmerus" :csv-headers="headersViagensMerus" csv-filename="viagensmerus" hide-search>
                    <template v-slot:add>
                        <v-btn color="primary" @click="adicionarViagem" fab small class="mr-2 mb-2">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:extension>
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" v-bind="attrs" v-on="on" fab small class="mr-2 mb-2">
                                    <v-icon dark>mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <strong>{{ $t('conciliacaoViagens.filters.title') }}</strong>
                                </v-card-title>
                                <v-card-text>
                                    <v-radio-group v-model="filtroViagem" column>
                                        <v-radio :label="$t('conciliacaoViagens.filters.all')" value="all"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.realized')"
                                            value="realizadas"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.withoutStart')"
                                            value="sem_inicio"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.withoutEnd')"
                                            value="sem_final"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.withoutConciliation')"
                                            value="sem_conciliacao"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.cancelled')" value="canceladas"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.alertKm')" value="alerta_km"></v-radio>
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </template>
                </CadastroToolbar>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon dark :color="getEditItemColor(item)" @click="editarViagem(item)" small :disabled="item.conciliacao_cancelada == 1">mdi-pencil</v-icon>
                <v-icon color="purple" @click="fazerConciliacaoManual(item)" small :disabled="item.sem_conciliacao == 0 || (viagemConciliacao !== null && viagemConciliacao != item) || item.conciliacao_cancelada == 1">mdi-format-align-middle</v-icon>
                <v-icon color="red" @click="openDesconciliarViagemDialog(item)" small :disabled="item.sem_conciliacao == 1">mdi-format-paragraph-spacing</v-icon>
                <v-icon :color="item.conciliacao_cancelada == 1 ? 'green' : 'red'" @click="openCacelarViagemDialog(item)" small :disabled="item.sem_conciliacao == 0">{{ item.conciliacao_cancelada == 1 ? 'mdi-check' : 'mdi-close' }}</v-icon>
            </template>
        </merus-data-table>

        <merus-data-table :headers="headersWithActionsOperadora" :items="viagensOperadoraFiltradas" :loading="loadingOperadora"
            :default-multi-sort="defaultMultiSortOperadora" :item-class="getViagemOperadoraStyle"
            :show-columns-button="true"
            :loading-text="$t('conciliacaoViagens.tables.operatorTrips.loading')"
            @update:headers="headersChangedOperadora"
            @update:displayedItems="displayedItemsForExportOperadora = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="titleViagensOperadora" :token="token"
                    :items="displayedItemsForExportOperadora !== null ? displayedItemsForExportOperadora : viagensOperadoraFiltradas"
                    :csv-title="$t('conciliacaoViagens.tables.operatorTrips.csvTitle')"
                    :pdf-title="$t('conciliacaoViagens.tables.operatorTrips.pdfTitle')" :pdf-headers="headersViagensOperadora"
                    pdf-filename="viagensoperadora" :csv-headers="headersViagensOperadora" csv-filename="viagensoperadora"
                    hide-search>
                    <template v-slot:extension v-if="viagemConciliacao === null">
                        <UploadDialog v-if="idEmpresaSelected" :token="token"
                            :endpoint="'/api/v1.0/uploadviagensoperadora/'" :user="user.id_usuario"
                            :url-params="[idEmpresaSelected]" size="s" icon="mdi-file-import" file-type="csv"
                            @done="handleDone" @error="handleError" />

                        <v-tooltip top v-if="viagensOperadoraFiltradas.length > 0 && idEmpresaSelected">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" @click="fazerConciliacaoAutomatica" fab small class="mr-2 mb-2"
                                    v-bind="attrs" v-on="on">
                                    <v-icon>mdi-format-align-middle</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('conciliacaoViagens.tables.operatorTrips.automaticConciliation') }}</span>
                        </v-tooltip>

                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" v-bind="attrs" v-on="on" fab small class="mr-2 mb-2">
                                    <v-icon dark>mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <strong>{{ $t('conciliacaoViagens.filters.title') }}</strong>
                                </v-card-title>
                                <v-card-text>
                                    <v-radio-group v-model="filtroViagemOperadora" column>
                                        <v-radio :label="$t('conciliacaoViagens.filters.all')" value="all"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.realized')"
                                            value="realizadas"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.notRealized')"
                                            value="nao_realizadas"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.withoutConciliation')"
                                            value="sem_conciliacao"></v-radio>
                                        <v-radio :label="$t('conciliacaoViagens.filters.alertKm')" value="alerta_km"></v-radio>
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </template>
                </CadastroToolbar>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-btn v-if="viagemConciliacao !== null" dark color="purple" @click="inserirMotivoConciliacao(item)" x-small>{{
                    $t('conciliacaoViagens.tables.operatorTrips.conciliate') }}</v-btn>
                <v-icon v-else dark color="blue" @click="detalhesViagemOperadora(item)" small>mdi-magnify</v-icon>
                <v-icon color="blue" dark small @click="editarViagem(item, 'operadora')">mdi-map-marker</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import UploadDialog from './Dialogs/UploadDialog.vue';
import L from "leaflet";
import { LMap, LTileLayer, LGeoJson, LCircle, LControl, LTooltip } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import TranslateHeader from "../middleware/traducao/TranslateHeader.js";
import translateDbField from "@/utils/translateDbField";
import fechamentoMesMixin from "@/mixins/fechamentoMesMixin";
import HodometrosViagemInfo from '@/components/Viagem/HodometrosViagemInfo.vue';
import { medeHodometros } from '@/utils/hodometroPreferencia';

export default {
    mixins: [fechamentoMesMixin],
    components: {
        MerusDataTable,
        CadastroToolbar,
        UploadDialog,
        LMap,
        LTileLayer,
        LGeoJson,
        LCircle,
        LControl,
        LTooltip,
        Vue2LeafletRotatedMarker,
        HodometrosViagemInfo
    },
    data: () => ({
        displayedItemsForExportMerus: null,
        displayedItemsForExportOperadora: null,
        search: "",
        user: null,
        token: null,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        currentCenter: null,
        mapOptions: {
            zoomSnap: 0.5,
        },
        zoom: 12,
        map: null,
        showCercas: true,
        showRota: true,
        showAlertVeiculosDistintos: false,
        key: 0,
        loading: false,
        empresas: [],
        idEmpresaSelected: null,
        veiculos: [],
        idVeiculoSelected: null,
        posicoes: [],
        loadingPosicoes: false,
        motivos: [],
        rotas: [],
        linhas: [],
        cercas: [],
        cercasGeojson: [],
        cercasCirculares: [],
        dti: null,
        dtf: null,
        dtiPosicoes: null,
        dtfPosicoes: null,
        posicaoSelected: null,
        timeProps: {
            useSeconds: true,
        },
        config: null,
        formValidado: false,
        viagensMerus: [],
        loadingMerus: false,
        viagensOperadora: [],
        loadingOperadora: false,
        headersViagensMerus: [],
        headersViagensOperadora: [],
        dialogEditarViagem: false,
        formValidadoEditarViagem: false,
        editedIndexViagem: -1,
        editedViagem: {
            id_viagem_grid: null,
            id_viagem_realizada: null,
            id_guia_realizada: null,
            numero_guia_realizada: null,
            id_veiculo_realizado: null,
            numero_ordem_veiculo_realizado: null,
            escalonamento_veiculo: null,
            id_motorista_realizado: null,
            matricula_motorista_realizado: null,
            nome_motorista_realizado: null,
            id_cobrador_realizado: null,
            matricula_cobrador_realizado: null,
            nome_cobrador_realizado: null,
            id_sentido: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            tempo_de_placa: null,
            passageiros_totais: null,
            passageiros_pagantes: null,
            passageiros_gratuidades: null,
            passageiros_vt: null,
            hodometro_inicial: null,
            dt_hodometro_inicial: null,
            hodometro_final: null,
            dt_hodometro_final: null,
            consumo_inicial: null,
            dt_consumo_inicial: null,
            consumo_final: null,
            dt_consumo_final: null,
            id_origem: null,
            temp_media: null,
            condicao_climatica: null,
            id_motivo_abertura_manual: null,
            observacoes_abertura_manual: null,
            id_motivo_fechamento_manual: null,
            observacoes_fechamento_manual: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_linha_associada: null,
            cod_linha_associada: null,
        },
        defaultViagem: {
            id_viagem_grid: null,
            id_viagem_realizada: null,
            id_guia_realizada: null,
            numero_guia_realizada: null,
            id_veiculo_realizado: null,
            numero_ordem_veiculo_realizado: null,
            escalonamento_veiculo: null,
            id_motorista_realizado: null,
            matricula_motorista_realizado: null,
            nome_motorista_realizado: null,
            id_cobrador_realizado: null,
            matricula_cobrador_realizado: null,
            nome_cobrador_realizado: null,
            id_sentido: null,
            id_cerca_inicio: null,
            nome_cerca_inicio: null,
            cod_cerca_inicio: null,
            id_cerca_fim: null,
            nome_cerca_fim: null,
            cod_cerca_fim: null,
            tempo_de_placa: null,
            passageiros_totais: null,
            passageiros_pagantes: null,
            passageiros_gratuidades: null,
            passageiros_vt: null,
            hodometro_inicial: null,
            dt_hodometro_inicial: null,
            hodometro_final: null,
            dt_hodometro_final: null,
            consumo_inicial: null,
            dt_consumo_inicial: null,
            consumo_final: null,
            dt_consumo_final: null,
            id_origem: null,
            temp_media: null,
            condicao_climatica: null,
            id_motivo_abertura_manual: null,
            observacoes_abertura_manual: null,
            id_motivo_fechamento_manual: null,
            observacoes_fechamento_manual: null,
            dt_abertura_manual: null,
            id_usuario_abertura_manual: null,
            dt_fechamento_manual: null,
            id_usuario_fechamento_manual: null,
            dt_associacao_manual: null,
            id_usuario_associacao_manual: null,
            id_linha_associada: null,
            cod_linha_associada: null,
        },
        viagemOperadoraSelected: {
            id_viagem: null,
            observacoes: null,
            id_viagem_grid: null,
            id_usuario_conciliacao: null,
            dt_conciliacao: null,
            id_linha: null,
            id_veiculo_realizado: null,
            id_motivo_conciliacao_manual: null,
            observacoes_conciliacao_manual: null,
        },
        defaultViagemOperadora: {
            id_viagem: null,
            observacoes: null,
            id_viagem_grid: null,
            id_usuario_conciliacao: null,
            dt_conciliacao: null,
            id_linha: null,
            id_veiculo_realizado: null,
            id_motivo_conciliacao_manual: null,
            observacoes_conciliacao_manual: null,
        },
        dialogDetalhesViagemOperadora: false,
        isVeiculoSelectDisabled: false,
        formValidadoDetalhesViagem: false,
        mapaPopulado: false,
        horarioSaidaRealizada: null,
        horarioChegadaRealizada: null,
        atualizadoPelaPosicao: false,
        idLinhaAssociada: null,
        idMotivoAbertura: null,
        observacoesAbertura: null,
        idMotivoFechamento: null,
        observacoesFechamento: null,
        dialogUploadResult: false,
        resultadoUpload: {
            mensagem: null,
            arquivoLog: null,
        },
        viagemConciliacao: null,
        dialogCancelarViagem: false,
        veiculosDistintos: [],
        filterDebounceTimeout: null,
        dialogInserirMotivoConciliacao: false,
        idMotivoConciliacao: null,
        observacoesConciliacao: null,
        tipoEdicao: null,
        filtroViagem: null,
        filtroViagemOperadora: null,
        center: null,
        dialogDesconciliarViagem: false,
        idMotivoDesconciliacao: null,
        observacoesDesconciliacao: null,
        viagemConciliada: null,
        loadingDesconciliarViagem: false,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            if (this.$refs.formEditarViagem) {
                this.$refs.formEditarViagem.resetValidation();
            }
            if (this.$refs.formDetalhesViagem) {
                this.$refs.formDetalhesViagem.resetValidation();
            }

        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    beforeDestroy() {
        // Limpar timeouts para evitar vazamentos de memória
        if (this.filterDebounceTimeout) {
            clearTimeout(this.filterDebounceTimeout);
        }
        // Limpar cache de ícones
        if (this._iconCache) {
            this._iconCache = null;
        }
    },
    computed: {
        /** Meses fechados dentro do período consultado, para o aviso no topo. */
        mesesFechadosConsultados() {
            return this.mesesFechadosNoIntervalo(this.dti, this.dtf, this.idEmpresaSelected);
        },
        /** A viagem aberta no diálogo está congelada por fechamento de mês. */
        viagemEditadaBloqueada() {
            return this.viagemEmMesFechado(this.editedViagem, this.idEmpresaSelected);
        },
        defaultMultiSortMerus() {
            return [
            { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
            { value: 'horario_saida_realizada_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } }];

        },
        defaultMultiSortOperadora() {
            return [
            { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
            { value: 'horario_saida_realizada_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } }];

        },
        sentidos() {
            return [
                { id_sentido: 1, descricao_sentido: this.$t('operation.go') },
                { id_sentido: 2, descricao_sentido: this.$t('operation.back') }]
        },
        motoristaConciliadoLabel() {
            const viagem = this.viagemConciliada;
            if (!viagem) {
                return '';
            }
            const matricula = viagem.matricula_motorista_realizado;
            const nome = viagem.nome_motorista_realizado;
            if (matricula && nome) {
                return `${matricula} - ${nome}`;
            }
            return matricula || nome || '';
        },
        linhaConciliadaLabel() {
            const viagem = this.viagemConciliada;
            if (!viagem) {
                return '—';
            }
            const codigo = viagem.cod_linha;
            const nome = viagem.nome_linha;
            if (codigo && nome) {
                return `${codigo} — ${nome}`;
            }
            return codigo || nome || '—';
        },
        erro() {
            return {
                tipo: this.$t('vehicleAuthorization.headers.system'),
                mensagem: this.$t('system.unknownSystemError'),
                status: null
            }
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('conciliacaoViagens.validation.selectDate')],
            }
        },
        // defaultMultiSortMerus() {
        //     return [
        //     { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        //     { value: 'horario_saida_realizada_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        // ]},
        // defaultMultiSortOperadora() {
        //     return [
        //     { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        //     { value: 'horario_saida_realizada_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        // ]},
        titleViagensOperadora() {
            if (this.viagemConciliacao !== null) {
                return this.$t('conciliacaoViagens.tables.operatorTrips.manualConciliation');
            }

            return this.idEmpresaSelected ? this.$t('conciliacaoViagens.tables.operatorTrips.title') + " " + this.empresas.find((e) => e.id_empresa == this.idEmpresaSelected).razao_social : this.$t('conciliacaoViagens.tables.operatorTrips.title');
        },
        headersViagens() {
            return [
                { text: this.$t('conciliacaoViagens.headers.id'), value: "id_viagem", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.line'), value: "cod_linha", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.vehicle'), value: "numero_ordem_veiculo_realizado", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.realizedDepartureTime'), value: "horario_saida_realizada_extenso", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.realizedArrivalTime'), value: "horario_chegada_realizada_extenso", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.direction'), value: "descricao_sentido", sortable: true, filtrable: true },
                { text: this.$t('tabelasfront.status'), value: "status_viagem", sortable: true, filtrable: true },
                { text: this.$t('tabelasfront.conciliated'), value: "conciliada", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.driver'), value: "matricula_motorista_realizado", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.collector'), value: "matricula_cobrador_realizado", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.startFence'), value: "nome_cerca_inicio", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.endFence'), value: "nome_cerca_fim", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.kmAferido'), value: "km_aferido", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.kmNominal'), value: "km_nominal", sortable: true, filtrable: true },
                { text: this.$t('tabelasfront.operatorKm'), value: "km_aferido_contraparte", sortable: true, filtrable: true },
                { text: this.$t('tabelasfront.diffMerusOperatorKm'), value: "diff_merus_operadora_km", sortable: true, filtrable: true },
                { text: this.$t('conciliacaoViagens.headers.actions'), value: "actions", sortable: false, filtrable: false }]
        },
        conciliacaoHeaderTextByValue() {
            const label = (i18nKey, ptFallback) => {
                const translated = this.$t(i18nKey);
                return translated !== i18nKey ? translated : ptFallback;
            };
            return {
                id_viagem: label('conciliacaoViagens.headers.id', 'ID'),
                cod_linha: label('conciliacaoViagens.headers.line', 'Linha'),
                numero_ordem_veiculo_realizado: label('conciliacaoViagens.headers.vehicle', 'Veículo'),
                horario_saida_realizada_extenso: label('conciliacaoViagens.headers.realizedDepartureTime', 'Horário Saída Realizado'),
                horario_chegada_realizada_extenso: label('conciliacaoViagens.headers.realizedArrivalTime', 'Horário Chegada Realizado'),
                descricao_sentido: label('conciliacaoViagens.headers.direction', 'Sentido'),
                status_viagem: label('tabelasfront.status', 'Status'),
                conciliada: label('tabelasfront.conciliated', 'Conciliada'),
                matricula_motorista_realizado: label('conciliacaoViagens.headers.driver', 'Motorista'),
                matricula_cobrador_realizado: label('conciliacaoViagens.headers.collector', 'Cobrador'),
                nome_cerca_inicio: label('conciliacaoViagens.headers.startFence', 'Cerca Início'),
                nome_cerca_fim: label('conciliacaoViagens.headers.endFence', 'Cerca Fim'),
                km_aferido: label('conciliacaoViagens.headers.kmAferido', 'Km Aferido'),
                km_nominal: label('conciliacaoViagens.headers.kmNominal', 'Km Nominal'),
                km_aferido_contraparte: label('tabelasfront.operatorKm', 'Km Operadora'),
                diff_merus_operadora_km: label('tabelasfront.diffMerusOperatorKm', 'Km Merus - Operadora'),
            };
        },
        headersWithActionsMerus() {
            return [...this.headersViagensMerus, { text: this.$t('conciliacaoViagens.headers.actions'), value: 'actions', sortable: false, filtrable: false, show: true }];
        },
        headersWithActionsOperadora() {
            return [...this.headersViagensOperadora, { text: this.$t('conciliacaoViagens.headers.actions'), value: 'actions', sortable: false, filtrable: false, show: true }];
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
                rules: [this.dtRules]
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
                rules: [this.dtRules]
            }
        },
        dateDiff() {
            let start = typeof this.dti === "string" ?
                new Date(this.dti.substring(6, 10), this.dti.substring(3, 5) - 1, this.dti.substring(0, 2), this.dti.substring(11, 13), this.dti.substring(14, 16), this.dti.substring(17, 19)) :
                this.dti;
            let end = typeof this.dtf === "string" ?
                new Date(this.dtf.substring(6, 10), this.dtf.substring(3, 5) - 1, this.dtf.substring(0, 2), this.dtf.substring(11, 13), this.dtf.substring(14, 16), this.dtf.substring(17, 19)) :
                this.dtf;

            return (end - start) / 3600000;
        },
        isLinhaDisabled() {
            // return this.editedIndexViagem !== -1;
            return this.tipoEdicao === "operadora";
        },
        isSentidoDisabled() {
            return this.editedIndexViagem !== -1 || this.tipoEdicao === "operadora";
        },
        isEscalonamentoDisabled() {
            return this.editedIndexViagem !== -1 || this.tipoEdicao === "operadora";
        },
        isVeiculoDisabled() {
            return this.editedIndexViagem !== -1 || this.tipoEdicao === "operadora";
        },
        isHorarioSaidaDisabled() {
            return !this.mapaPopulado || this.tipoEdicao === "operadora";
        },
        isHorarioChegadaDisabled() {
            return !this.mapaPopulado || this.tipoEdicao === "operadora";
        },
        isCercaInicioDisabled() {
            return !this.mapaPopulado;
        },
        isCercaFimDisabled() {
            return !this.mapaPopulado;
        },
        isMotivoAberturaDisabled() {
            return !this.mapaPopulado;
        },
        isObservacoesAberturaDisabled() {
            return !this.mapaPopulado;
        },
        isMotivoFechamentoDisabled() {
            return !this.mapaPopulado;
        },
        isObservacoesFechamentoDisabled() {
            return !this.mapaPopulado;
        },
        selectedLinha() {
            if (!this.idLinhaAssociada) return null;
            return this.linhas.find(linha => linha.id_linha === this.idLinhaAssociada);
        },
        viagensMerusFiltradas() {
            // Ensure viagensMerus is always an array
            if (!Array.isArray(this.viagensMerus)) {
                return [];
            }

            if (this.viagemConciliacao !== null) {
                return [this.viagemConciliacao];
            }

            if (this.filtroViagem === 'all' || !this.filtroViagem) {
                return this.viagensMerus;
            }

            // Usar filter mais eficiente com early return
            const filterFunctions = {
                canceladas: (v) => v.conciliacao_cancelada === 1,
                sem_inicio: (v) => v.sem_inicio === 1 && v.conciliacao_cancelada === 0,
                sem_final: (v) => v.sem_final === 1 && v.conciliacao_cancelada === 0,
                realizadas: (v) => v.sem_inicio === 0 && v.sem_final === 0 && v.conciliacao_cancelada === 0,
                sem_conciliacao: (v) => v.sem_conciliacao === 1 && v.conciliacao_cancelada === 0,
                alerta_km: (v) => v.alerta_km === 1 && v.conciliacao_cancelada === 0 && v.sem_conciliacao === 0
            };

            const filterFn = filterFunctions[this.filtroViagem];
            return filterFn ? this.viagensMerus.filter(filterFn) : this.viagensMerus;
        },
        viagensOperadoraFiltradas() {
            // Ensure viagensOperadora is always an array
            if (!Array.isArray(this.viagensOperadora)) {
                return [];
            }

            if (this.viagemConciliacao !== null) {
                // Otimizar com variáveis locais
                const idVeiculo = this.viagemConciliacao.id_veiculo_realizado;
                const idLinha = this.viagemConciliacao.id_linha;
                return this.viagensOperadora.filter((v) => 
                    v.sem_conciliacao === 1 && 
                    v.id_veiculo_realizado === idVeiculo && 
                    v.id_linha === idLinha
                );
            }

            if (this.filtroViagemOperadora === 'all' || !this.filtroViagemOperadora) {
                return this.viagensOperadora;
            }

            // Usar filter mais eficiente
            const filterFunctions = {
                realizadas: (v) => v.realizada === 1,
                nao_realizadas: (v) => v.realizada === 0,
                sem_conciliacao: (v) => v.sem_conciliacao === 1 && v.realizada === 1,
                alerta_km: (v) => v.alerta_km === 1 && v.sem_conciliacao === 0 && v.realizada === 1
            };

            const filterFn = filterFunctions[this.filtroViagemOperadora];
            return filterFn ? this.viagensOperadora.filter(filterFn) : this.viagensOperadora;
        }
    },
    methods: {
        async initialize() {
            this.currentCenter = this.center;
            this.config = await this.getConfig();
            this.getHeadersViagensMerus();
            this.getHeadersViagensOperadora();
            this.populaEmpresas();
            this.populaLinhas();
            this.populaVeiculos();
            this.populaMotivos();
        },
        resolveHeaderText(header) {
            if (!header) return '';

            const byValue = this.conciliacaoHeaderTextByValue[header.value];
            if (byValue) return byValue;

            const translated = translateDbField(header.translation_key, header.text);
            if (translated && !String(translated).startsWith('config.headersConfigTable.')) {
                return translated;
            }

            const fromLegacy = TranslateHeader(header);
            if (fromLegacy && !String(fromLegacy).startsWith('config.headersConfigTable.')) {
                return fromLegacy;
            }

            return header.text || '';
        },
        hasStaleConciliacaoHeaders(headers) {
            return (headers || []).some((header) => {
                const text = header?.text;
                return typeof text === 'string' && (
                    text.startsWith('config.headersConfigTable.') ||
                    text === 'Conductor'
                );
            });
        },
        getHeadersViagensMerus() {
            let headersSession = sessionStorage.getItem("headersConciliacaoViagens");
            if (headersSession) {
                try {
                    const parsed = JSON.parse(headersSession);
                    if (this.hasStaleConciliacaoHeaders(parsed)) {
                        sessionStorage.removeItem("headersConciliacaoViagens");
                        this.fetchHeadersViagensMerusFromAPI();
                        return;
                    }
                    this.headersViagensMerus = parsed.map(header => ({
                        ...header,
                        text: this.resolveHeaderText(header)
                    }));
                } catch (e) {
                    console.error("Error parsing headers from sessionStorage:", e);
                    this.fetchHeadersViagensMerusFromAPI();
                }
            } else {
                this.fetchHeadersViagensMerusFromAPI();
            }
        },
        fetchHeadersViagensMerusFromAPI() {
            apiController.request(apiController.endpoints.getHeaderstabela, {
                params: { cod: "VIAGENSMERUS" },
                silent: true,
                onSuccess: (response) => {
                    this.headersViagensMerus = response.data.map(header => ({
                        ...header,
                        text: this.resolveHeaderText(header)
                    }));
                    sessionStorage.setItem("headersConciliacaoViagens", JSON.stringify(this.headersViagensMerus));
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.erro.tipo = this.$t('system.errors.DEFAULT.type');
                        this.erro.mensagem = e.response?.data?.mensagem || this.$t('system.messages.accessDenied');
                        this.erro.status = 401;
                        this.$refs.erroSistema.showError();
                    }
                },
            });
        },
        headersChanged(updatedHeaders) {
            if (updatedHeaders) {
                updatedHeaders.forEach((updated) => {
                    const match = this.headersViagensMerus.find((h) => h.value === updated.value);
                    if (match) match.show = updated.show;
                });
            }
            sessionStorage.setItem("headersConciliacaoViagens", JSON.stringify(this.headersViagensMerus));
        },
        getHeadersViagensOperadora() {
            let headersSession = sessionStorage.getItem("headersConciliacaoViagensOperadora");
            if (headersSession) {
                try {
                    const parsed = JSON.parse(headersSession);
                    if (this.hasStaleConciliacaoHeaders(parsed)) {
                        sessionStorage.removeItem("headersConciliacaoViagensOperadora");
                        this.fetchHeadersViagensOperadoraFromAPI();
                        return;
                    }
                    this.headersViagensOperadora = parsed.map(header => ({
                        ...header,
                        text: this.resolveHeaderText(header)
                    }));
                } catch (e) {
                    console.error("Error parsing headers from sessionStorage:", e);
                    this.fetchHeadersViagensOperadoraFromAPI();
                }
            } else {
                this.fetchHeadersViagensOperadoraFromAPI();
            }
        },
        fetchHeadersViagensOperadoraFromAPI() {
            apiController.request(apiController.endpoints.getHeaderstabela, {
                params: { cod: "VIAGENSOPERADORA" },
                silent: true,
                onSuccess: (response) => {
                    this.headersViagensOperadora = response.data.map(header => ({
                        ...header,
                        text: this.resolveHeaderText(header)
                    }));
                    sessionStorage.setItem("headersConciliacaoViagensOperadora", JSON.stringify(this.headersViagensOperadora));
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.erro.tipo = this.$t('system.errors.DEFAULT.type');
                        this.erro.mensagem = e.response?.data?.mensagem || this.$t('system.messages.accessDenied');
                        this.erro.status = 401;
                        this.$refs.erroSistema.showError();
                    }
                },
            });
        },
        headersChangedOperadora(updatedHeaders) {
            if (updatedHeaders) {
                updatedHeaders.forEach((updated) => {
                    const match = this.headersViagensOperadora.find((h) => h.value === updated.value);
                    if (match) match.show = updated.show;
                });
            }
            sessionStorage.setItem("headersConciliacaoViagensOperadora", JSON.stringify(this.headersViagensOperadora));
        },
        async getConfig() {
            const response = await apiController.request(apiController.endpoints.getallConfig, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }


            [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(response.data[0].hora_inicial_dia_operacao);
            this.center = [response.data[0].lat_default, response.data[0].lng_default];
            this.currentCenter = this.center;
            return response.data[0];
        },
        async populaEmpresas() {
            const response = await apiController.request(apiController.endpoints.getallEmpresas, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.empresas = response.data;
        },
        async populaLinhas() {
            const response = await apiController.request(apiController.endpoints.getLinhasativas, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.linhas = response.data;
        },
        async populaVeiculos() {
            const response = await apiController.request(apiController.endpoints.getallVeiculosativos, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.veiculos = response.data;
        },
        async populaMotivos() {
            const response = await apiController.request(apiController.endpoints.getallMotivos, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.motivos = response.data;
        },
        async populaViagensMerus() {
            if (!this.idEmpresaSelected) {
                console.warn('populaViagensMerus - idEmpresaSelected is null or undefined');
                this.viagensMerus = [];
                this.loadingMerus = false;
                return;
            }

            this.loadingMerus = true;
            // Meses fechados da empresa, para avisar e bloquear a edição das viagens congeladas.
            this.carregaFechamentosMesAtivos(this.idEmpresaSelected);
            let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
            let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

            try {
            const response = await apiController.request(apiController.endpoints.getViagensmerusconciliacao, {
                data: { idOperadora: this.idEmpresaSelected, dti: dataInicial, dtf: dataFinal },
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                    this.viagensMerus = [];
                    this.loadingMerus = false;
                    return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                    this.viagensMerus = [];
                    this.loadingMerus = false;
                    return;
            }

                // Ensure response.data is always an array
                const data = Array.isArray(response.data) ? response.data : [];
            this.loadingMerus = false;
            this.viagensMerus = data;
            } catch (error) {
                EventBus.$emit('show-error', { error });
                this.viagensMerus = [];
                this.loadingMerus = false;
            }
        },
        async populaViagensOperadora() {
            if (!this.idEmpresaSelected) {
                console.warn('populaViagensOperadora - idEmpresaSelected is null or undefined');
                this.viagensOperadora = [];
                this.loadingOperadora = false;
                return;
            }

            this.loadingOperadora = true;
            let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
            let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

            try {
            const response = await apiController.request(apiController.endpoints.getViagensoperadoraconcialicao, {
                data: { idempresa: this.idEmpresaSelected, dti: dataInicial, dtf: dataFinal },
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                    this.viagensOperadora = [];
                    this.loadingOperadora = false;
                    return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                    this.viagensOperadora = [];
                    this.loadingOperadora = false;
                    return;
            }

                // Ensure response.data is always an array
                const data = Array.isArray(response.data) ? response.data : [];
            this.loadingOperadora = false;
            console.log(data);
            // Object.freeze para dados imutáveis - melhora performance do Vue
                this.viagensOperadora = data;
            } catch (error) {
                EventBus.$emit('show-error', { error });
                this.viagensOperadora = [];
                this.loadingOperadora = false;
            }
        },
        async populaPosicoes() {
            this.loadingPosicoes = true;
            const payload = {
                id: this.idVeiculoSelected,
                dti: DateUtils.getDateSQLFormatted(this.dtiPosicoes),
                dtf: DateUtils.getDateSQLFormatted(this.dtfPosicoes)
            }
            const response = await apiController.request(apiController.endpoints.getPosicoesporcarrodata, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loadingPosicoes = false;
            this.posicoes = response.data;
            if (this.posicoes.length > 0) {
                this.currentCenter = [this.posicoes[0].lat, this.posicoes[0].lng];
            }
        },
        async populaRotas() {
            const response = await apiController.request(apiController.endpoints.getRotasporlinha, {
                data: [this.idLinhaAssociada],
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            let rotas = response.data;
            if (rotas.length > 0) {
                this.rotas = rotas.filter((rota) => rota.id_sentido == this.editedViagem.id_sentido).map((rota) => {
                    rota.geojson = JSON.parse(rota.geojson);
                    return rota;
                });
            }
        },
        async populaCercas() {
            const response = await apiController.request(apiController.endpoints.getCercasporlinha, {
                data: [this.idLinhaAssociada],
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            let cercas = response.data;
            if (cercas.length > 0) {
                this.cercas = cercas.filter((cerca) => cerca.id_sentido == this.editedViagem.id_sentido || cerca.id_sentido == -1).map((cerca) => {
                    let color = cerca.id_tipo_cerca == 2 || cerca.id_tipo_cerca == 3 ? "#43A047" : "#4287f5";
                    cerca.style = {
                        color: color,
                        weight: 1,
                        fillColor: color,
                        fillOpacity: 0.3
                    };
                    cerca.geojson = JSON.parse(cerca.geojson);
                    // Add onEachFeature for non-circular stops to show tooltips
                    if (cerca.is_circular == 0) {
                        cerca.options = {
                            onEachFeature: (feature, layer) => {
                                if (cerca.nome_cerca) {
                                    layer.bindTooltip(cerca.nome_cerca);
                                }
                            }
                        };
                    }
                    return cerca;
                });
                this.cercasCirculares = this.cercas.filter((cerca) => cerca.is_circular == 1);
                this.cercasGeojson = this.cercas.filter((cerca) => cerca.is_circular == 0);
            }
        },
        populaVeiculosDistintos() {
            this.veiculosDistintos = [];

            if (this.viagensMerus.length > 0 && this.viagensOperadora.length > 0) {
                // Otimização: usar Set para busca O(1) em vez de some() O(n)
                // Filtrar valores nulos/undefined antes de criar o Set
                const veiculosMerusSet = new Set(
                    this.viagensMerus
                        .filter(vm => vm.id_veiculo_realizado != null)
                        .map(vm => vm.id_veiculo_realizado)
                );
                
                this.veiculosDistintos = [...new Set(
                    this.viagensOperadora
                        .filter((v) => 
                            v.id_veiculo_realizado != null && 
                            v.numero_ordem_veiculo_realizado != null &&
                            v.numero_ordem_veiculo_realizado !== '' &&
                            !veiculosMerusSet.has(v.id_veiculo_realizado)
                        )
                        .map((v) => v.numero_ordem_veiculo_realizado)
                )];
            }
        },
        async getHodometro() {
            const payload = {
                idveiculo: this.editedViagem.id_veiculo_realizado,
                dti: this.editedViagem.horario_saida_realizada,
                dtf: this.editedViagem.horario_chegada_realizada
            }
            const response = await apiController.request(apiController.endpoints.getHodometrokmcarro, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            return response.data;
        },
        async populaRelatorio() {
            this.$refs.form.validate();
            if (this.formValidado) {
                this.veiculosDistintos = [];
                this.viagensMerus = [];
                this.viagensOperadora = [];
                Promise.all([this.populaViagensMerus(), this.populaViagensOperadora()])
                .then(() => {
                    this.populaVeiculosDistintos();
                    if (this.veiculosDistintos.length > 0) {
                        EventBus.$emit('show-alert', {
                            mensagem: `Há veículos da operadora sem viagens válidas no Merus: ${this.veiculosDistintos.join(' ')}`,
                            tipo: 'warning',
                            duracao: 8000
                        });
                    }
                });
                this.$nextTick(() => { this.$refs.form.resetValidation(); });
            }
        },
        async populaMapa(bypassValidation = false) {
            this.$refs.formEditarViagem.validate();
            if (this.formValidadoEditarViagem || bypassValidation) {
                this.mapaPopulado = true;
                this.populaPosicoes();
                this.populaRotas();
                this.populaCercas();
            }
        },
        async insertEntradaDiario(idmotivo, observacoes) {
            const payload = {
                id_tipo_entrada_diario: 1,
                id_motivo: idmotivo,
                dt_entrada: DateUtils.getDateSQLFormatted(new Date()),
                id_usuario_inclusao: this.user.id_usuario,
                observacoes: observacoes,
            }

            const response = await apiController.request(apiController.endpoints.insertEntrada, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            return response.data.insertId;
        },
        async insertEntradaLinhas(idEntrada, idLinha) {
            const payload = [[idEntrada, idLinha]];

            const response = await apiController.request(apiController.endpoints.insertLinhasentradabulk, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            return;
        },
        async insertEntradaVeiculos(idEntrada, idVeiculo) {
            const payload = [[idEntrada, idVeiculo]];

            const response = await apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            return;
        },
        async updateViagemOperadora() {
            const payload = {
                id_viagem: this.viagemOperadoraSelected.id_viagem,
                observacoes: this.viagemOperadoraSelected.observacoes,
            }
            const response = await apiController.request(apiController.endpoints.updateViagemoperadora, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            EventBus.$emit('show-alert', {
                mensagem: 'Viagem da operadora atualizada com sucesso',
                tipo: 'success'
            });
            this.closeDialogDetalhesViagemOperadora();
            this.populaViagensOperadora();
            return;
        },
        openCacelarViagemDialog(item) {
            this.editedViagem = Object.assign({}, item);
            this.dialogCancelarViagem = true;
        },
        closeCancelarViagemDialog() {
            this.dialogCancelarViagem = false;
            this.editedViagem = Object.assign({}, this.defaultViagem);
        },
        cancelarViagemChanged() {
            if (this.editedViagem.conciliacao_cancelada == 0) {
                this.editedViagem.id_motivo_conciliacao_cancelada = null;
                this.editedViagem.observacoes_conciliacao_cancelada = null;
            }
        },
        async cancelarViagem(item) {
            const payload = {
                idviagem: item.id_viagem_grid,
                conciliacao_cancelada: item.conciliacao_cancelada,
                idmotivo: item.id_motivo_conciliacao_cancelada,
                observacoes: item.observacoes_conciliacao_cancelada,
                idusuario: this.user.id_usuario,
            };

            let response;
            try {
                response = await apiController.request(apiController.endpoints.updateConciliacaocanceladamerus, {
                    data: payload,
                    silent: true,
                });
            } catch (error) {
                // Mês fechado (409) já foi avisado pelo apiController; aqui só fechamos o
                // diálogo para o usuário não ficar preso num formulário que não salva.
                if (apiController.isErroMesFechado(error)) {
                    this.closeCancelarViagemDialog();
                    return;
                }
                EventBus.$emit('show-error', { error });
                return;
            }

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            if (item.conciliacao_cancelada == 1 && item.id_motivo_conciliacao_cancelada != null) {
                const idEntrada = await this.insertEntradaDiario(item.id_motivo_conciliacao_cancelada, item.observacoes_conciliacao_cancelada);
                await this.insertEntradaLinhas(idEntrada, item.id_linha);
                await this.insertEntradaVeiculos(idEntrada, item.id_veiculo_realizado);
            }

            EventBus.$emit('show-alert', {
                mensagem: response.data.mensagem,
                tipo: 'success'
            });
            this.populaViagensMerus();
            this.closeCancelarViagemDialog();
            return;
        },
        getViagemStyle(item) {
            if (item.conciliacao_cancelada === 1) {
                return "viagem_cancelada";
            }

            if (item.sem_inicio === 1 || item.sem_final === 1) {
                return "viagem__invalida";
            }

            if (item.alerta_km === 1) {
                return "viagem__km_divergente";
            }

            return "viagem__valida";
        },
        getViagemOperadoraStyle(item) {
            if (item.realizada === 0) {
                return "viagem__invalida";
            }

            if (item.alerta_km === 1) {
                return "viagem__km_divergente";
            }

            return "viagem__valida";
        },
        getEditItemColor(item) {
            // Usar comparação estrita para melhor performance
            if (item.sem_inicio === 1 || item.sem_final === 1) {
                return "red";
            }

            if (item.sem_conciliacao === 1) {
                return "rgb(236, 102, 0)";
            }

            return "green";
        },
        async handleDone(data) {
            this.resultadoUpload.mensagem = data.message;
            this.resultadoUpload.arquivoLog = data.arqlog;
            this.dialogUploadResult = true;
        },
        async closeDialogUploadResult() {
            this.dialogUploadResult = false;
            this.resultadoUpload = Object.assign({}, {mensagem: null, arquivoLog: null});
            this.populaViagensOperadora();
        },
        baseName(str) {
            var base = new String(str).substring(str.lastIndexOf("/") + 1);
            return base;
        },
        async baixarLog() {
            const response = await apiController.request(apiController.endpoints.downloadLog, {
                params: { filename: this.baseName(this.resultadoUpload.arquivoLog) },
                config: { responseType: "blob" },
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.baseName(this.resultadoUpload.arquivoLog));
            document.body.appendChild(link);
            link.click();
            this.closeDialogUploadResult();
        },
        handleError(error) {
            EventBus.$emit('show-error', { error });
        },
        editarViagem(item, tipo = "merus") {
            this.tipoEdicao = tipo;
            this.editedViagem = Object.assign({}, item);
            this.idLinhaAssociada = item.id_linha;
            this.horarioSaidaRealizada = item.horario_saida_realizada ? new Date(item.horario_saida_realizada) : null;
            this.horarioChegadaRealizada = item.horario_chegada_realizada ? new Date(item.horario_chegada_realizada) : null;
            this.dtiPosicoes = item.horario_saida_realizada ? new Date(item.horario_saida_realizada) : null;
            this.dtfPosicoes = item.horario_chegada_realizada ? new Date(item.horario_chegada_realizada) : null;
            this.idMotivoAbertura = item.id_motivo_abertura_manual;
            this.observacoesAbertura = item.observacoes_abertura_manual;
            this.idMotivoFechamento = item.id_motivo_fechamento_manual;
            this.observacoesFechamento = item.observacoes_fechamento_manual;
            this.idVeiculoSelected = item.id_veiculo_realizado;
            this.isVeiculoSelectDisabled = true;
            this.editedIndexViagem = this.viagensMerus.indexOf(item);
            this.key = this.key == 0 ? 1 : 0;
            this.dialogEditarViagem = true;
            if (item.horario_saida_realizada && item.horario_chegada_realizada) {
                const camposValidos = this.idVeiculoSelected &&
                    this.idLinhaAssociada &&
                    this.editedViagem.id_sentido &&
                    this.dtiPosicoes &&
                    this.dtfPosicoes;
                this.$nextTick(() => { this.populaMapa(camposValidos); });
            }
        },
        adicionarViagem() {
            this.isVeiculoSelectDisabled = false;
            this.dialogEditarViagem = true;
        },
        closeDialogEditarViagem() {
            this.dialogEditarViagem = false;
            this.editedViagem = Object.assign({}, this.defaultViagem);
            this.editedIndexViagem = -1;
            this.isVeiculoSelectDisabled = false;
            this.idVeiculoSelected = null;
            this.dtiPosicoes = null;
            this.dtfPosicoes = null;
            this.horarioSaidaRealizada = null;
            this.horarioChegadaRealizada = null;
            this.$refs.horarioSaidaRealizadaPicker.clearHandler();
            this.$refs.horarioChegadaRealizadaPicker.clearHandler();
            this.$refs.dtiPosicoesPicker.clearHandler();
            this.$refs.dtfPosicoesPicker.clearHandler();
            this.posicoes = [];
            this.rotas = [];
            this.cercas = [];
            this.cercasCirculares = [];
            this.cercasGeojson = [];
            this.posicaoSelected = null;
            this.mapaPopulado = false;
            this.atualizadoPelaPosicao = false;
            this.idLinhaAssociada = null;
            this.idMotivoAbertura = null;
            this.observacoesAbertura = null;
            this.idMotivoFechamento = null;
            this.observacoesFechamento = null;
            // Limpar cache de ícones
            if (this._iconCache) {
                this._iconCache = {};
            }
            this.$refs.formEditarViagem.resetValidation();
            this.$refs.formDetalhesViagem.resetValidation();
        },
        detalhesViagemOperadora(item) {
            this.viagemOperadoraSelected = Object.assign({}, item);
            this.dialogDetalhesViagemOperadora = true;
        },
        closeDialogDetalhesViagemOperadora() {
            this.dialogDetalhesViagemOperadora = false;
            this.viagemOperadoraSelected = Object.assign({}, this.defaultViagemOperadora);
        },
        atualizarViagem(tipo) {
            if (tipo == 1) {
                this.editedViagem.horario_saida_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(this.horarioSaidaRealizada);
                this.editedViagem.horario_saida_realizada_extenso = this.editedViagem.horario_saida_realizada.substring(11, 16);
                this.horarioSaidaRealizada = new Date(this.editedViagem.horario_saida_realizada);
                this.editedViagem.dt_abertura_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_abertura_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_abertura_manual = this.user.id_usuario;
                this.editedViagem.tipo_abertura = "Manual";
            } else {
                this.editedViagem.horario_chegada_realizada = this.posicaoSelected ? DateUtils.getDateSQLFormatted(new Date(this.posicaoSelected?.dt_posicao)) : DateUtils.getDateSQLFormatted(this.horarioChegadaRealizada);
                this.editedViagem.horario_chegada_realizada_extenso = this.editedViagem.horario_chegada_realizada.substring(11, 16);
                this.horarioChegadaRealizada = new Date(this.editedViagem.horario_chegada_realizada);
                this.editedViagem.dt_fechamento_manual = DateUtils.getDateSQLFormatted(new Date());
                this.editedViagem.dt_fechamento_manual_extenso = new Date().toLocaleString();
                this.editedViagem.id_usuario_fechamento_manual = this.user.id_usuario;
                this.editedViagem.tipo_fechamento = "Manual";
            }

            this.posicaoSelected = null;
            this.atualizadoPelaPosicao = true;
        },
        async updateViagemGrid() {
            this.$refs.formDetalhesViagem.validate();
            if (this.formValidadoDetalhesViagem) {
                if (!this.atualizadoPelaPosicao) {
                    this.atualizarViagem(1);
                    this.atualizarViagem(2);
                }

                if (this.editedViagem.id_cerca_inicio && !this.editedViagem.nome_cerca_inicio) {
                    let cercaInicio = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_inicio);
                    this.editedViagem.nome_cerca_inicio = cercaInicio?.nome_cerca;
                    this.editedViagem.cod_cerca_inicio = cercaInicio?.cod_cerca;
                }

                if (this.editedViagem.id_cerca_fim && !this.editedViagem.nome_cerca_fim) {
                    let cercaFim = this.cercas.find((cerca) => cerca.id_cerca == this.editedViagem.id_cerca_fim);
                    this.editedViagem.nome_cerca_fim = cercaFim?.nome_cerca;
                    this.editedViagem.cod_cerca_fim = cercaFim?.cod_cerca;
                }

                if (this.idLinhaAssociada != this.editedViagem.id_linha || this.editedViagem.id_linha == null) {
                    const linhaAssociada = this.linhas.find((linha) => linha.id_linha == this.idLinhaAssociada);
                    this.editedViagem.id_linha_associada = this.idLinhaAssociada;
                    this.editedViagem.cod_linha_associada = linhaAssociada.cod_linha;
                    this.editedViagem.dt_associacao_manual = DateUtils.getDateSQLFormatted(new Date());
                    this.editedViagem.id_usuario_associacao_manual = this.user.id_usuario;
                    if (this.editedViagem.id_linha == null) {
                        this.editedViagem.id_linha = this.idLinhaAssociada;
                        this.editedViagem.cod_linha = linhaAssociada.cod_linha;
                    }
                }

                if (this.editedViagem.id_veiculo_realizado != this.idVeiculoSelected || this.editedViagem.id_veiculo_realizado == null) {
                    const veiculoAssociado = this.veiculos.find((veiculo) => veiculo.id_veiculo == this.idVeiculoSelected);
                    this.editedViagem.id_veiculo_realizado = this.idVeiculoSelected;
                    this.editedViagem.numero_ordem_veiculo_realizado = veiculoAssociado.numero_ordem;
                }

                // Verificar mudanças no motivo de abertura
                if (this.idMotivoAbertura !== this.editedViagem.id_motivo_abertura_manual ||
                    this.observacoesAbertura !== this.editedViagem.observacoes_abertura_manual) {
                    this.editedViagem.id_motivo_abertura_manual = this.idMotivoAbertura;
                    this.editedViagem.observacoes_abertura_manual = this.observacoesAbertura;
                    if (this.idMotivoAbertura) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoAbertura, this.observacoesAbertura);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                    }
                }

                // Verificar mudanças no motivo de fechamento
                if (this.idMotivoFechamento !== this.editedViagem.id_motivo_fechamento_manual ||
                    this.observacoesFechamento !== this.editedViagem.observacoes_fechamento_manual) {
                    this.editedViagem.id_motivo_fechamento_manual = this.idMotivoFechamento;
                    this.editedViagem.observacoes_fechamento_manual = this.observacoesFechamento;
                    if (this.idMotivoFechamento) {
                        const idEntrada = await this.insertEntradaDiario(this.idMotivoFechamento, this.observacoesFechamento);
                        await this.insertEntradaLinhas(idEntrada, this.editedViagem.id_linha);
                        await this.insertEntradaVeiculos(idEntrada, this.editedViagem.id_veiculo_realizado);
                    }
                }

                let hodometro = await this.getHodometro();

                // Preferência de hodômetro (switch do card): fonte das leituras gravadas; o km
                // final é recalculado no backend com as duas medições.
                const hodometrosViagem = this.$refs.hodometrosViagem;
                let hodometrosMedidos = null;
                if (hodometro.length > 0) {
                    const medicao = medeHodometros(hodometro[0], hodometrosViagem ? hodometrosViagem.prefereVirtual() : false);
                    this.editedViagem.hodometro_inicial = medicao.hodometro_inicial;
                    this.editedViagem.dt_hodometro_inicial = medicao.dt_hodometro_inicial;
                    this.editedViagem.hodometro_final = medicao.hodometro_final;
                    this.editedViagem.dt_hodometro_final = medicao.dt_hodometro_final;
                    this.editedViagem.km_aferido = medicao.km_aferido;
                    hodometrosMedidos = medicao.hodometros_medidos;
                }

                const linha = this.linhas.find((linha) => linha.id_linha == this.editedViagem.id_linha || linha.id_linha == this.idLinhaAssociada);
                this.editedViagem.km_nominal = this.editedViagem.id_sentido == 1 ? linha.distancia_ida : linha.distancia_volta;

                let payload = {
                    id_viagem_realizada: this.editedViagem.id_viagem_realizada,
                    id_guia: this.editedViagem.id_guia_realizada,
                    id_linha: this.editedViagem.id_linha,
                    cod_linha: this.editedViagem.cod_linha,
                    id_sentido: this.editedViagem.id_sentido,
                    numero_guia: this.editedViagem.numero_guia_realizada,
                    id_veiculo: this.editedViagem.id_veiculo_realizado,
                    numero_ordem: this.editedViagem.numero_ordem_veiculo_realizado,
                    dt_inicio: this.editedViagem.horario_saida_realizada,
                    dt_fim: this.editedViagem.horario_chegada_realizada,
                    escalonamento: this.editedViagem.escalonamento_veiculo,
                    id_motorista: this.editedViagem.id_motorista_realizado,
                    matricula_motorista: this.editedViagem.matricula_motorista_realizado,
                    nome_motorista: this.editedViagem.nome_motorista_realizado,
                    id_cobrador: this.editedViagem.id_cobrador_realizado,
                    matricula_cobrador: this.editedViagem.matricula_cobrador_realizado,
                    nome_cobrador: this.editedViagem.nome_cobrador_realizado,
                    id_status: this.editedViagem.id_status,
                    hodometro_inicio: this.editedViagem.hodometro_inicial,
                    dt_hodometro_inicio: this.editedViagem.dt_hodometro_inicial,
                    hodometro_fim: this.editedViagem.hodometro_final,
                    dt_hodometro_fim: this.editedViagem.dt_hodometro_final,
                    consumo_inicio: this.editedViagem.consumo_inicial,
                    dt_consumo_inicio: this.editedViagem.dt_consumo_inicial,
                    consumo_fim: this.editedViagem.consumo_final,
                    dt_consumo_fim: this.editedViagem.dt_consumo_final,
                    id_origem: this.editedViagem.id_origem,
                    temp_media: this.editedViagem.temp_media,
                    condicao_climatica: this.editedViagem.condicao_climatica,
                    id_usuario_abertura_manual: this.editedViagem.id_usuario_abertura_manual,
                    dt_abertura_manual: this.editedViagem.dt_abertura_manual,
                    id_usuario_fechamento_manual: this.editedViagem.id_usuario_fechamento_manual,
                    dt_fechamento_manual: this.editedViagem.dt_fechamento_manual,
                    id_usuario_associacao_manual: this.editedViagem.id_usuario_associacao_manual,
                    dt_associacao_manual: this.editedViagem.dt_associacao_manual,
                    tempo_de_placa: this.editedViagem.tempo_de_placa,
                    id_cerca_inicio: this.editedViagem.id_cerca_inicio,
                    cod_cerca_inicio: this.editedViagem.cod_cerca_inicio,
                    nome_cerca_inicio: this.editedViagem.nome_cerca_inicio,
                    id_cerca_fim: this.editedViagem.id_cerca_fim,
                    cod_cerca_fim: this.editedViagem.cod_cerca_fim,
                    nome_cerca_fim: this.editedViagem.nome_cerca_fim,
                    passageiros_totais: this.editedViagem.passageiros_totais,
                    passageiros_pagantes: this.editedViagem.passageiros_pagantes,
                    passageiros_gratuidades: this.editedViagem.passageiros_gratuidades,
                    passageiros_vt: this.editedViagem.passageiros_vt,
                    id_motivo_abertura_manual: this.editedViagem.id_motivo_abertura_manual,
                    id_motivo_fechamento_manual: this.editedViagem.id_motivo_fechamento_manual,
                    observacoes_abertura_manual: this.editedViagem.observacoes_abertura_manual,
                    observacoes_fechamento_manual: this.editedViagem.observacoes_fechamento_manual,
                    id_viagem_grid: this.editedViagem.id_viagem_grid,
                    km_aferido: this.editedViagem.km_aferido,
                    km_nominal: this.editedViagem.km_nominal,
                    id_linha_associada: this.editedViagem.id_linha_associada,
                    cod_linha_associada: this.editedViagem.cod_linha_associada,
                    processar_viagem: true,
                    hodometros_medidos: hodometrosMedidos,
                    ...(hodometrosViagem ? hodometrosViagem.alteracaoPreferencia() : {})
                };

                let response;

                if (this.editedIndexViagem === -1) {
                    const dataInicio = this.editedViagem.horario_saida_realizada

                    const horaInicialConfig = this.config?.hora_inicial_dia_operacao || "03:00";
                    const [horaConfig, minConfig] = horaInicialConfig.split(":").map(Number);

                    const dataInicioComparacao = new Date(dataInicio);
                    dataInicioComparacao.setHours(horaConfig, minConfig, 0, 0);

                    let dtReferenciaDate;
                    if (dataInicio < dataInicioComparacao) {
                        // Subtrai 1 dia
                        dtReferenciaDate = new Date(dataInicio);
                        dtReferenciaDate.setDate(dtReferenciaDate.getDate() - 1);
                    } else {
                        dtReferenciaDate = new Date(dataInicio);
                    }

                    // Formata para yyyymmdd
                    const yyyymmdd = dtReferenciaDate.getFullYear().toString() +
                        String(dtReferenciaDate.getMonth() + 1).padStart(2, '0') +
                        String(dtReferenciaDate.getDate()).padStart(2, '0');

                    payload.dt_referencia = yyyymmdd;

                    response = await apiController.request(apiController.endpoints.insertViagemgrid, {
                        data: payload,
                        silent: true,
                    });
                } else {
                    response = await apiController.request(apiController.endpoints.updateViagemgrid, {
                        data: payload,
                        silent: true,
                    });
                }

                if (response.status !== 200) {
                    EventBus.$emit('show-error', { error: { response, status: response.status } });
                    return;
                }

                if (response.data.error) {
                    EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                    return;
                }

                console.log(response.data);

                EventBus.$emit('show-alert', {
                    mensagem: response.data.mensagem,
                    tipo: 'success'
                });
                this.populaViagensMerus();
                this.closeDialogEditarViagem();
            }
        },
        async fazerConciliacaoAutomatica() {
            this.loadingMerus = true;
            this.loadingOperadora = true;

            const response = await apiController.request(apiController.endpoints.conciliaCaoautomatica, {
                data: {
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                    idOperadora: this.idEmpresaSelected,
                    idUsuario: this.user.id_usuario,
                },
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                this.loadingMerus = false;
                this.loadingOperadora = false;
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                this.loadingMerus = false;
                this.loadingOperadora = false;
                return;
            }

            EventBus.$emit('show-alert', {
                mensagem: response.data.mensagem,
                tipo: 'success'
            });
            this.populaViagensMerus();
            this.populaViagensOperadora();
        },
        fazerConciliacaoManual(item) {
            if (this.viagemConciliacao) {
                this.viagemConciliacao = null;
            } else {
                this.viagemConciliacao = item;
            }
        },
        inserirMotivoConciliacao(item) {
            this.viagemOperadoraSelected = Object.assign({}, item);
            this.idMotivoConciliacao = item.id_motivo_conciliacao_manual;
            this.observacoesConciliacao = item.observacoes_conciliacao_manual;
            this.dialogInserirMotivoConciliacao = true;
        },
        closeDialogInserirMotivoConciliacao() {
            this.dialogInserirMotivoConciliacao = false;
            this.viagemOperadoraSelected = Object.assign({}, this.defaultViagemOperadora);
            this.idMotivoConciliacao = null;
            this.observacoesConciliacao = null;
        },
        async conciliar(item) {
            if (this.idMotivoConciliacao !== item.id_motivo_conciliacao_manual || 
                this.observacoesConciliacao !== item.observacoes_conciliacao_manual) {
                item.id_motivo_conciliacao_manual = this.idMotivoConciliacao;
                item.observacoes_conciliacao_manual = this.observacoesConciliacao;
                if (this.idMotivoConciliacao) {
                    const idEntrada = await this.insertEntradaDiario(this.idMotivoConciliacao, this.observacoesConciliacao);
                    await this.insertEntradaLinhas(idEntrada, item.id_linha);
                    await this.insertEntradaVeiculos(idEntrada, item.id_veiculo_realizado);
                }
            }
            
            const payload = {
                id_viagem: item.id_viagem,
                id_viagem_grid: this.viagemConciliacao.id_viagem_grid,
                id_usuario_conciliacao: this.user.id_usuario,
                dt_conciliacao: DateUtils.getDateSQLFormatted(new Date()),
                id_motivo_conciliacao_manual: this.idMotivoConciliacao,
                observacoes_conciliacao_manual: this.observacoesConciliacao,
                id_motivo_desconciliacao_manual: this.viagemConciliada?.id_motivo_desconciliacao_manual,
                observacoes_desconciliacao_manual: this.viagemConciliada?.observacoes_desconciliacao_manual,
                dt_desconciliacao_manual: this.viagemConciliada?.dt_desconciliacao_manual,
                id_usuario_desconciliacao_manual: this.viagemConciliada?.id_usuario_desconciliacao_manual,
            };

            const response = await apiController.request(apiController.endpoints.conciliaCaomanual, {
                data: payload,
                silent: true,
            });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return;
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return;
            }

            EventBus.$emit('show-alert', {
                mensagem: response.data.mensagem,
                tipo: 'success'
            });
            this.viagemConciliacao = null;
            this.populaViagensMerus();
            this.populaViagensOperadora();
            this.closeDialogInserirMotivoConciliacao();
        },
        onMapReady() {
            this.map = this.$refs.map.mapObject;
            this.onMapResize();
        },
        onMapResize() {
            this.$refs.map.mapObject.invalidateSize();
        },
        showDetalhesPosicoes(k) {
            const posicao = this.posicoes[k];
            // Usar comparação estrita e evitar atribuição desnecessária
            if (this.posicaoSelected?.dt_posicao === posicao.dt_posicao) {
                this.posicaoSelected = null;
            } else {
                this.posicaoSelected = posicao;
            }
        },
        getIconPosicao(reg) {
            const isSelected = this.posicaoSelected && reg.dt_posicao === this.posicaoSelected.dt_posicao;
            const color = isSelected ? "green" : "#4A4A4A";

            // Cache de ícones para evitar recriação desnecessária
            if (!this._iconCache) {
                this._iconCache = {};
            }

            if (!this._iconCache[color]) {
                this._iconCache[color] = L.divIcon({
                    className: "my-custom-pin",
                    html: `<svg width="20" height="20" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                            <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                            <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`,
                    iconAnchor: [15, 15]
                });
            }

            return this._iconCache[color];
        },
        latLng(lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(this.center[0], this.center[1]);
                }
            } else {
                return L.latLng(this.center[0], this.center[1]);
            }
        },
        openDesconciliarViagemDialog(item) {
            this.viagemConciliada = this.viagensOperadora.find(v => v.id_viagem == item.id_viagem_conciliada);
            this.idMotivoDesconciliacao = null;
            this.observacoesDesconciliacao = null;
            this.dialogDesconciliarViagem = true;
        },
        closeDialogDesconciliarViagem() {
            this.dialogDesconciliarViagem = false;
            this.idMotivoDesconciliacao = null;
            this.observacoesDesconciliacao = null;
            this.viagemConciliada = null;
        },
        desconciliarViagem() {
            this.loadingDesconciliarViagem = true;
            const payload = {
                id_viagem: this.viagemConciliada.id_viagem,
                id_viagem_grid: null,
                id_usuario_conciliacao: this.viagemConciliada.id_usuario_conciliacao,
                dt_conciliacao: this.viagemConciliada.dt_conciliacao,
                id_motivo_conciliacao_manual: this.viagemConciliada.id_motivo_conciliacao_manual,
                observacoes_conciliacao_manual: this.viagemConciliada.observacoes_conciliacao_manual,
                id_usuario_desconciliacao_manual: this.user.id_usuario,
                dt_desconciliacao_manual: DateUtils.getDateSQLFormatted(new Date()),
                id_motivo_desconciliacao_manual: this.idMotivoDesconciliacao,
                observacoes_desconciliacao_manual: this.observacoesDesconciliacao,
            };

            apiController.request(apiController.endpoints.conciliaCaomanual, {
                data: payload,
                silent: true,
                onSuccess: () => {
                    this.closeDialogDesconciliarViagem();
                    this.populaViagensMerus();
                    this.populaViagensOperadora();
                    this.loadingDesconciliarViagem = false;
                },
                onError: () => {
                    this.closeDialogDesconciliarViagem();
                    this.loadingDesconciliarViagem = false;
                },
            });
        },
    },
}
</script>

<style>
#mapcontainer {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.viagem__valida {
    color: green;
    font-weight: bold;
}

.viagem__reassociada {
    color: purple;
    font-weight: bold;
}

.viagem__km_divergente {
    color: red;
    font-weight: bold;
}

.viagem__invalida {
    color: rgb(236, 102, 0);
    font-weight: bold;
}

.viagem_cancelada {
    color: grey;
}

.viagem-ident-card {
    border-radius: 8px;
}

.viagem-ident-block {
    min-height: 48px;
    padding: 4px 0;
}
</style>
